module.exports = __webpack_public_path__ + "img/sys6-select.664d8c59.png";